/**
 * fontDB — stockage IndexedDB des polices IMPORTÉES par l'utilisateur (.ttf/.otf/...).
 *
 * Pourquoi IndexedDB et pas localStorage : un fichier de police pèse souvent
 * 100 Ko – 1 Mo, et localStorage (~5 Mo, déjà utilisé pour l'autosave et les
 * fonts Google) n'est pas adapté aux blobs. IndexedDB stocke nativement des
 * Blob et offre largement la place.
 *
 * Une entrée = { family (clé), blob, type, addedAt }.
 *   - family : nom de la police tel qu'utilisé dans le projet (font-family)
 *   - blob   : le fichier de police (réutilisé pour l'affichage ET l'export)
 *
 * Tout est best-effort : si IndexedDB est indisponible, les fonctions rejettent
 * et l'appelant retombe sur le comportement par défaut (pas de crash).
 */
const DB_NAME = 'labelforge-fonts';
const STORE = 'fonts';
const DB_VERSION = 1;

function openDB() {
    return new Promise((resolve, reject) => {
        if (typeof indexedDB === 'undefined') {
            reject(new Error('IndexedDB indisponible'));
            return;
        }
        const req = indexedDB.open(DB_NAME, DB_VERSION);
        req.onupgradeneeded = () => {
            const db = req.result;
            if (!db.objectStoreNames.contains(STORE)) {
                db.createObjectStore(STORE, { keyPath: 'family' });
            }
        };
        req.onsuccess = () => resolve(req.result);
        req.onerror = () => reject(req.error || new Error('Ouverture IndexedDB échouée'));
    });
}

function run(mode, fn) {
    return openDB().then((db) => new Promise((resolve, reject) => {
        const store = db.transaction(STORE, mode).objectStore(STORE);
        const req = fn(store);
        req.onsuccess = () => resolve(req.result);
        req.onerror = () => reject(req.error);
    }));
}

/** Ajoute / remplace une police. entry = { family, blob, type, addedAt } */
export function putFont(entry) {
    return run('readwrite', (s) => s.put(entry)).then(() => entry);
}

/** Renvoie toutes les polices importées : [{ family, blob, type, addedAt }] */
export function getAllFonts() {
    return run('readonly', (s) => s.getAll()).then((r) => r || []);
}

/** Supprime une police importée par son nom de famille. */
export function deleteFont(family) {
    return run('readwrite', (s) => s.delete(family));
}
